<template>
  <v-dialog v-model="dialog" max-width="500px" @click:outside="_onNo">
    <v-card title="Are you sure?" class="mb-0">
      <v-card-title class="ma-2 text-center d-block">
        <span>Are you sure you want to proceed?</span>
        <br />
        <span>{{ message }}</span>
      </v-card-title>
      <v-divider class="ma-2"></v-divider>
      <v-card-actions class="ma-2 text-center">
        <v-spacer></v-spacer>
        <v-btn
          color="white"
          name="Cancel"
          class="text-right mr-10"
          @click="_onNo()"
          >NO</v-btn
        >
        <v-btn color="primary" name="Add" class="text-right ml-10" @click="_onYes()"
          >YES</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialog: {
      default: false,
    },
    message: {
      default: "",
    },
  },
  methods: {
    _onYes() {
      this.$emit("confirm");
      this.$emit("update:dialog", false);
    },
    _onNo() {
      this.$emit("update:dialog", false);
    }
  },
};
</script>
<style scoped>
</style>
